import { gql } from '@apollo/client';

export const deactivateChargerGroupPlanForExtend = gql`
  mutation deactivateChargerGroupPlanForExtend($input: DeactivateChargerGroupPlanForExtendInput!) {
    deactivateChargerGroupPlanForExtend(input: $input) {
      altId
    }
  }
`;
